import { apiService } from "api/apiService";
import type { StudentsSearch200 } from "api/generated";
import { studentSearchResultFromDto } from "shared/mappers/studentSearchResult.mapper";
import type { StudentSearchResponse } from "shared/types";

export const fetchStudentSearchResults = async (
  search: string,
  signal?: AbortSignal,
): Promise<StudentSearchResponse> => {
  const { data } = await apiService.get<StudentsSearch200>(
    "api/students/search",
    { params: { search }, signal },
  );

  return {
    results: data.data.map(studentSearchResultFromDto),
    scopedToTeacher: data.meta.scoped_to_teacher,
  };
};
